import React from "react";
import { useEffect, useState } from "react";
import { accountRolesAndPermissions, AccountRolesAndPermissionsResponse } from "../../../../../modules/apis/UserApi";
import Pill from "../../../Pill";
import { StatusDto } from "../../../../../enums/Domain/Status";
import { UserPermissionsLevelSmartEnum } from "../../../../../enums/Domain/UserPermissionsLevelSmartEnum";
import IconRefresh from "../../../../../assets/icons/icon-refresh.svg"
import { Button } from "react-aria-components";

interface ISidePanelUserAccess {
    targetUserId: string
}

// Emulate two versions of this for operator and customer access display
export default function SidePanelUserAccess({ targetUserId }: ISidePanelUserAccess) {
    const [accountRolesData, setAccountRolesData] = useState<AccountRolesAndPermissionsResponse>();
    const [canRender, setCanRender] = useState<boolean>(false);

    function getStatus(level: number) {
        const statusDto = new StatusDto(level, UserPermissionsLevelSmartEnum.getName())
        return statusDto;
    }

    async function getData() {
        if (targetUserId) {
            setCanRender(false);
            const data = await accountRolesAndPermissions(targetUserId);
            setAccountRolesData(data);
            setCanRender(true);
        }
    }

    useEffect(() => {
        getData()
    }, [targetUserId])

    return (<>
        {!canRender &&
            <div className="side-panel__info-box margin__top--s">
                <div className={`display--flex alignItems--center flex__direction--column gap--s`}>
                    <div className={`form__wrapper form__wrapper`}>
                        <div className="loaders loaders__panel form__inline-loader"></div>
                    </div>
                </div>
            </div>
        }
        {canRender && accountRolesData &&
            <div className="side-panel__info-box margin__top--s">
                <div className="display--flex justifyContent--space-between alignItems--center">
                    <p className="small margin__bottom--xs">Roles & Access permissions</p>
                    <Button
                        isDisabled={false}
                        className={"button button--secondary button--with-icon button--extra-small"}
                        onPress={getData}>
                        <img src={IconRefresh}></img>
                        <p className="button-text button-text--small">Refresh</p>
                    </Button>
                </div>
                <div>
                    {accountRolesData?.accountRolesAndPermissionsViewModel.customerAccess.map(x =>
                        <div className="side-panel__inline">
                            <p className="small">{x.customerName}</p>
                            <ul>
                                {x.accessModels.map(y =>
                                    <li>
                                        <div className="side-panel-user-access__item">
                                            <p>{y.descriptor}</p>
                                            <Pill statusDto={getStatus(y.level)} />
                                        </div>
                                    </li>
                                )}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        }
    </>
    )
}